/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState } from './HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateToJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateToJSONTyped,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace } from './HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceToJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceToJSONTyped,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace';

/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    s3_photo_key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    photo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    marital_status?: HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoMaritalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    primary_language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    contact_method_preference?: HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoContactMethodPreferenceEnum;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    current_address?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    state_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    race_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    religion?: HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoReligionEnum;
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    race?: HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRace;
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo
     */
    state?: HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState;
}


/**
 * @export
 */
export const HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoMaritalStatusEnum = {
    Single: 'single',
    DomesticPartner: 'domestic_partner',
    Married: 'married',
    Separated: 'separated',
    Divorced: 'divorced',
    Widowed: 'widowed',
    UnknownDeclined: 'unknown_declined'
} as const;
export type HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoMaritalStatusEnum = typeof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoMaritalStatusEnum[keyof typeof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoMaritalStatusEnum];

/**
 * @export
 */
export const HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoContactMethodPreferenceEnum = {
    Email: 'Email',
    Text: 'Text',
    Call: 'Call',
    Other: 'Other'
} as const;
export type HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoContactMethodPreferenceEnum = typeof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoContactMethodPreferenceEnum[keyof typeof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoContactMethodPreferenceEnum];

/**
 * @export
 */
export const HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoReligionEnum = {
    _7thDayAdventist: '7th Day Adventist',
    Atheist: 'Atheist',
    Agnostic: 'Agnostic',
    Apolistic: 'Apolistic',
    Apostolic: 'Apostolic',
    AssemblyOfGod: 'Assembly of God',
    Baptist: 'Baptist',
    Buddhist: 'Buddhist',
    Catholic: 'Catholic',
    Congregational: 'Congregational',
    Christian: 'Christian',
    ChristianScientist: 'Christian Scientist',
    ChurchOfChrist: 'Church of Christ',
    ChristianMissionaryAlliance: 'Christian Missionary Alliance',
    ChurchOfTheNazarene: 'Church of the Nazarene',
    ChristianReformed: 'Christian Reformed',
    Covenant: 'Covenant',
    DisciplesOfChrist: 'Disciples of Christ',
    Episcopalian: 'Episcopalian',
    Evangelical: 'Evangelical',
    FirstAssembly: 'First Assembly',
    GreekOrthodox: 'Greek Orthodox',
    Hinduism: 'Hinduism',
    Islam: 'Islam',
    Judaism: 'Judaism',
    JehovahsWitness: 'Jehovah\'s Witness',
    Lutheran: 'Lutheran',
    ChurchOfTheLatterDaySaints: 'Church of the Latter Day Saints',
    Methodist: 'Methodist',
    Mennonite: 'Mennonite',
    Mormon: 'Mormon',
    Moravian: 'Moravian',
    None: 'None',
    NonDenominational: 'Non-Denominational',
    Orthodox: 'Orthodox',
    Protestant: 'Protestant',
    Pentecostal: 'Pentecostal',
    Presbyterian: 'Presbyterian',
    Quaker: 'Quaker',
    Scientology: 'Scientology',
    Taoist: 'Taoist',
    Traditional: 'Traditional',
    Unitarian: 'Unitarian',
    Unknown: 'Unknown'
} as const;
export type HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoReligionEnum = typeof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoReligionEnum[keyof typeof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoReligionEnum];


/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo(value: object): value is HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo {
    return true;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        's3_photo_key': json['s3_photo_key'] == null ? undefined : json['s3_photo_key'],
        'photo_url': json['photo_url'] == null ? undefined : json['photo_url'],
        'marital_status': json['marital_status'] == null ? undefined : json['marital_status'],
        'primary_language': json['primary_language'] == null ? undefined : json['primary_language'],
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
        'email': json['email'] == null ? undefined : json['email'],
        'contact_method_preference': json['contact_method_preference'] == null ? undefined : json['contact_method_preference'],
        'current_address': json['current_address'] == null ? undefined : json['current_address'],
        'state_id': json['state_id'] == null ? undefined : json['state_id'],
        'race_id': json['race_id'] == null ? undefined : json['race_id'],
        'religion': json['religion'] == null ? undefined : json['religion'],
        'race': json['race'] == null ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceFromJSON(json['race']),
        'state': json['state'] == null ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateFromJSON(json['state']),
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoToJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoToJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoToJSONTyped(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        's3_photo_key': value['s3_photo_key'],
        'photo_url': value['photo_url'],
        'marital_status': value['marital_status'],
        'primary_language': value['primary_language'],
        'phone_number': value['phone_number'],
        'email': value['email'],
        'contact_method_preference': value['contact_method_preference'],
        'current_address': value['current_address'],
        'state_id': value['state_id'],
        'race_id': value['race_id'],
        'religion': value['religion'],
        'race': HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoRaceToJSON(value['race']),
        'state': HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateToJSON(value['state']),
    };
}

